import React from 'react';
import '../../components/FeatureBlock/FeatureBlock.css';

function FeatureBlock({
                          title,
                          points,
                          linkText,
                          linkHref,
                          imageSrc,
                          reversed = false,
                      }) {
    return (
        <div className={`feature-block ${reversed ? 'reversed' : ''}`}>
            <div className="feature-image">
                <img src={imageSrc} alt="Feature" />
            </div>
            <div className="feature-content">
                <h3>{title}</h3>
                <ul>
                    {points.map((point, index) => (
                        <li key={index}>{point}</li>
                    ))}
                </ul>
                <a href={linkHref} className="feature-link">
                    {linkText}
                </a>
            </div>
        </div>
    );
}

export default FeatureBlock;


// WEBPACK FOOTER //
// ./src/components/FeatureBlock/FeatureBlock.js